import { memo } from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
// Components
import Layout from 'components/App/Layout/Layout';
// Views
import ProtectedManagerRoute from './ProtectedManagerRoute/ProtectedManagerRoute';
import Patients from 'views/Patients/Patients';
import Dashboard from 'views/Dashboard/Dashboard';
import Managers from 'views/Managers/Managers';
import Locations from 'views/Locations/Locations';
import Clinicians from 'views/Clinicians/Clinicians';
import Settings from 'views/Settings/Settings';
import Authentication from 'views/Authentication/Authentication';
import AppointmentFlows from 'views/Flows/AppointmentFlows/AppointmentFlows';
import FirstFlows from 'views/Flows/FirstFlows/FirstFlows';
import SecondFlows from 'views/Flows/SecondFlows/SecondFlows';
import ThirdFlows from 'views/Flows/ThirdFlows/ThirdFlows';
import FifthFlows from 'views/Flows/FifthFlows/FifthFlows';
import SixthFlows from 'views/Flows/SixthFlows/SixthFlows';
import SeventhFlows from 'views/Flows/SeventhFlows/SeventhFlows';
import WaterfallFlows from 'views/Flows/WaterfallFlows/WaterfallFlows';
import FillFlows from 'views/Flows/FillFlows/FillFlows';
import EsignFlows from 'views/Flows/EsignFlows/EsignFlows';
import VoiceFlows from 'views/Flows/VoiceFlows/VoiceFlows';
import ReminderFlows from 'views/Flows/ReminderFlows/ReminderFlows';
import ReferralFlows from 'views/Flows/ReferralFlows/ReferralFlows';
import ScheduleFlows from 'views/Flows/ScheduleFlows/ScheduleFlows';
import StudyFlows from 'views/Flows/StudyFlows/StudyFlows';
import ConfirmFlows from 'views/Flows/ConfirmFlows/ConfirmFlows';
import PenStudyFlows from 'views/Flows/PenStudyFlows/PenStudyFlows';
import SuperbillFlows from 'views/Flows/SuperbillFlows/SuperbillFlows';
import BookFlows from 'views/Flows/BookFlows/BookFlows';
import PatientFlows from 'views/Flows/PatientFlows/PatientFlows';
import FlowsNavigation from 'views/Flows/FlowsNavigation/FlowsNavigation';
import TemplateBuilder from 'views/TemplateBuilder/TemplateBuilder';
import Builder from 'views/Builder/Builder';

const App = () => {

  return (
    <Routes>
      <Route path='/sign_in' element={<Authentication />} />
      <Route path='/sign_up' element={<Authentication />} />
      <Route path='*' element={<Navigate replace to='/' />} />
      <Route path='/' element={<Layout />}>
        <Route path='builder' element={<ProtectedManagerRoute><Builder /></ProtectedManagerRoute>} />
        <Route path='dashboard' element={<ProtectedManagerRoute><Dashboard /></ProtectedManagerRoute>} />
        <Route path='patients' element={<ProtectedManagerRoute><Patients /></ProtectedManagerRoute>}>
          <Route path=':patient_id' element={Outlet} />
        </Route>
        <Route path='users' element={<ProtectedManagerRoute><Managers /></ProtectedManagerRoute>}>
          <Route path=':user_id' element={Outlet} />
        </Route>
        <Route path='locations' element={<ProtectedManagerRoute><Locations /></ProtectedManagerRoute>}>
          <Route path=':location_id' element={Outlet} />
        </Route>
        <Route path='providers' element={<ProtectedManagerRoute><Clinicians /></ProtectedManagerRoute>}>
          <Route path=':clinician_id' element={Outlet} />
        </Route>
        <Route path='settings' element={<ProtectedManagerRoute><Settings /></ProtectedManagerRoute>} />
        <Route path='i/:invitation_token' element={null} />
        <Route path='b/:token' element={null} />
        <Route path='admin_access/:admin_access_token' element={null} />
        <Route path='nylas_callback' element={null} />
        <Route path='flows_list' element={<ProtectedManagerRoute><FlowsNavigation /></ProtectedManagerRoute>} />
        <Route path='flow/fl88a' element={<ProtectedManagerRoute><AppointmentFlows /></ProtectedManagerRoute>}>
          <Route path=':appointment_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl11s' element={<ProtectedManagerRoute><FirstFlows /></ProtectedManagerRoute>}>
          <Route path=':first_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl22n' element={<ProtectedManagerRoute><SecondFlows /></ProtectedManagerRoute>}>
          <Route path=':second_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl33b' element={<ProtectedManagerRoute><ThirdFlows /></ProtectedManagerRoute>}>
          <Route path=':third_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl55d' element={<ProtectedManagerRoute><FifthFlows /></ProtectedManagerRoute>}>
          <Route path=':fifth_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl66p' element={<ProtectedManagerRoute><SixthFlows /></ProtectedManagerRoute>}>
          <Route path=':sixth_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl77e' element={<ProtectedManagerRoute><SeventhFlows /></ProtectedManagerRoute>}>
          <Route path=':seventh_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl87e' element={<ProtectedManagerRoute><WaterfallFlows /></ProtectedManagerRoute>}>
          <Route path=':waterfall_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl99f' element={<ProtectedManagerRoute><FillFlows /></ProtectedManagerRoute>}>
          <Route path=':fill_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl10e' element={<ProtectedManagerRoute><EsignFlows /></ProtectedManagerRoute>}>
          <Route path=':esign_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl12v' element={<ProtectedManagerRoute><VoiceFlows /></ProtectedManagerRoute>}>
          <Route path=':voice_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl93t' element={<ProtectedManagerRoute><ReminderFlows /></ProtectedManagerRoute>}>
          <Route path=':reminder_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl04r' element={<ProtectedManagerRoute><ReferralFlows /></ProtectedManagerRoute>}>
          <Route path=':referral_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl54s' element={<ProtectedManagerRoute><ScheduleFlows /></ProtectedManagerRoute>}>
          <Route path=':schedule_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl29s' element={<ProtectedManagerRoute><StudyFlows /></ProtectedManagerRoute>}>
          <Route path=':study_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl09c' element={<ProtectedManagerRoute><ConfirmFlows /></ProtectedManagerRoute>}>
          <Route path=':confirm_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl30c' element={<ProtectedManagerRoute><PenStudyFlows /></ProtectedManagerRoute>}>
          <Route path=':pen_study_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl19s' element={<ProtectedManagerRoute><SuperbillFlows /></ProtectedManagerRoute>}>
          <Route path=':superbill_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl93b' element={<ProtectedManagerRoute><BookFlows /></ProtectedManagerRoute>}>
          <Route path=':book_analysis_id' element={Outlet} />
        </Route>
        <Route path='flow/fl71p' element={<ProtectedManagerRoute><PatientFlows /></ProtectedManagerRoute>}>
          <Route path=':patient_analysis_id' element={Outlet} />
        </Route>
        <Route path='templates/:template_id/builder' element={<ProtectedManagerRoute><TemplateBuilder /></ProtectedManagerRoute>} />
        <Route path='fill_templates/:fill_template_id' element={<ProtectedManagerRoute><TemplateBuilder /></ProtectedManagerRoute>} />
        <Route path='esign_templates/:esign_template_id' element={<ProtectedManagerRoute><TemplateBuilder /></ProtectedManagerRoute>} />
      </Route>
    </Routes>
  );
};

export default memo(App);